/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Moderationreviewedby2Inputs */

const en_moderationreviewedby2 = /** @type {(inputs: Moderationreviewedby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`by ${i?.name}`)
};

const de_moderationreviewedby2 = /** @type {(inputs: Moderationreviewedby2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`von ${i?.name}`)
};

/**
* | output |
* | --- |
* | "by {name}" |
*
* @param {Moderationreviewedby2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationreviewedby2 = /** @type {((inputs: Moderationreviewedby2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationreviewedby2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationreviewedby2(inputs)
	return de_moderationreviewedby2(inputs)
});
export { moderationreviewedby2 as "moderationReviewedBy" }